<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     布局-Header
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="the-layout-header flex align-items-center justify-content-space-between"
    :class="{ 'is-collapse': isCollapse }">
    <div role="button" class="hd flex align-items-center" @click="toFrame">
      <i :class="'iconfont text-primary header-icon icon-' + ($route.meta.frame == 'todo' ? 'wait' : $route.meta.frame)"></i>
      <div class="font-md ml-sm">{{ $store.state.permissionStore.currentFrame.title }}</div>
    </div>

    <div class="ft flex align-items-center">
      <el-input placeholder="搜索" prefix-icon="el-icon-search" v-model="keyword" @keyup.enter.native="toSearch" clearable
        class="mr-lg search">
        <i v-if="!keyword" @click="advancedSearch = true" class="el-icon-s-operation el-input__icon iconfont icon-style"
          slot="suffix">
        </i>
      </el-input>
      <!-- <el-tag role="button" v-if="god.aiot_version == 0" type="primary" class="flex-center mr-lg" @click="toUpdate">
        <div class="flex-center">
          <i class="iconfont icon-upgrade-b" style="font-size: 24px;"></i>
          <div class="ml-xs text-bold">升 级</div>
        </div>
      </el-tag> -->

      <el-button v-if="god.aiot_version" icon="iconfont header-icon icon-report" class="icon-btn" @click="report"></el-button>

      <el-button icon="iconfont header-icon icon-Fnc" class="icon-btn mr-lg" @click="$router.push('/fnc/notice')"></el-button>

      <el-popover placement="bottom-end" width="280" :offset="0" :visible-arrow="false" trigger="hover" popper-class="tool-pop">
        <div class="pop_hd pb pt pl pr">
          <div class="font-lg mb-sm">{{ $store.state.userStore.username }}</div>
          <div v-if="$store.state.godStore.full_name" class="mb-xs">{{ $store.state.godStore.full_name }}</div>
          <div v-if="$store.state.godStore.certified === 1" class>
            <div class="text-primary flex align-items-center mt-sm">
              <i class="iconfont icon-autherized" role="button"></i>
              <div class="ml-sm">{{ "已实名认证" }}</div>
            </div>
          </div>
          <div v-else-if="$store.state.godStore.certified === 2" class>
            <div class="text-warning flex align-items-center mt-sm">
              <i class="iconfont icon-authenticating" role="button"></i>
              <div class="ml-sm">{{ "认证审核中" }}</div>
            </div>
          </div>
          <div v-else role="button" class="flex align-items-center text-danger" @click="$router.push('/fam/certify')">
            <i class="iconfont icon-unauthenticated" role="button"></i>
            <div class="ml-sm">{{ "未实名认证" }}</div>
          </div>
        </div>
        <div class="pop_content" role="button">
          <div class="pop-item" @click="$router.push('/fam/me')">
            <i class="iconfont icon-Fam text-muted" role="button"></i>
            <div class="ml-sm">{{ "账号中心" }}</div>
          </div>
          <div class="pop-item" @click="$router.push('/expense')">
            <i class="iconfont icon-Expense text-muted" role="button"></i>
            <div class="ml-sm">{{ "费用中心" }}</div>
          </div>
          <el-divider></el-divider>
          <div class="pop-item" @click="fullscreenSwitch()">
            <i v-if="isFullscreen" class="iconfont icon-Exit-full-screen text-muted" role="button"></i>
            <i v-else class="iconfont icon-full-screen-mode text-muted" role="button"></i>
            <div class="ml-sm">{{ isFullscreen ? '退出全屏' : '全屏模式' }}</div>
          </div>
          <el-divider></el-divider>
          <div class="pop-item" @click="logout()">
            <i class="iconfont icon-exit text-muted" role="button"></i>
            <div class="ml-sm">{{ "退出登录" }}</div>
          </div>
        </div>
        <div slot="reference" class="flex">
          <div role="button">{{ $store.state.userStore.username }}</div>
        </div>
      </el-popover>
    </div>

    <advanced-search v-if="advancedSearch" :show.sync="advancedSearch" :keyword="keyword"></advanced-search>
  </div>
</template>

<script>
import screenfull from "screenfull";
export default {
  name: "TheLayoutHeader",
  components: {
    AdvancedSearch: () => import('./components/AdvancedSearch.vue'),
  },

  data() {
    return {
      isFullscreen: false,
      keyword: "",
      advancedSearch: false,
      // secondTimerId: null,
      // pollingCt: 60,
      // counter: 0,
    };
  },

  computed: {
    god() {
      return this.$store.state.godStore;
    },

    isCollapse() {
      return this.$store.state.commonStore.collapse;
    }
  },
  watch: {
    $route(to, from) {
      if(to.fullPath != from.fullPath) {
        this.keyword = ""
      }
    },
  },
  created() {
  },

  beforeDestroy() {
    if (this.secondTimerId) {
      clearInterval(this.secondTimerId);
    }
  },

  methods: {
    report() {
      this.$router.push("/home/report")
    },

    toFrame() {
      this.$router.push({ name: this.$route.meta.frame });
    },

    // toUpdate() {
    //   this.$router.push("/home/upgrade")
    // },

    handleSelect(path) {
      if (path === "FullScreen") {
        this.fullscreenSwitch();
      } else if (path === "LogOut") {
        this.logout();
      } else {
        this.$router.push(path);
      }
    },

    fullscreenSwitch() {
      if (!screenfull.enabled) {
        this.$message.error("您的浏览器不支持全屏模式！");
        return false;
      }
      this.isFullscreen = !screenfull.isFullscreen;
      screenfull.toggle();
    },

    logout() {
      this.$store.dispatch("logOut").then(() => {
        location.reload();
      });
    },

    toSearch() {
      if (!this.keyword) return
      this.advancedSearch = true
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .search {
  &:hover {
    .el-input__inner {
      width: 200px;
      border-radius: 18px;
      font-size: 14px;
      border: 1px solid rgba(7, 193, 96, 1);
      transition: width 0.2s ease;
      &:focus {
        width: 300px;
      }
    }
  }

  .el-input__inner {
    width: 200px;
    border-radius: 18px;
    font-size: 14px;
    border: 1px solid rgba(220, 223, 230, 1);
    transition: width 0.2s ease;

    &:focus {
      width: 300px;
      border: 1px solid rgba(7, 193, 96, 1);
    }
  }
}
</style>

<style lang="scss">
.the-layout-header {
  position: fixed;
  top: 0;
  height: 60px;
  left: 160px;
  right: 0;
  background-color: #fff;
  padding: 0 30px;
  box-shadow: 0px 0px 6px 0 rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #eee;
  border-top-left-radius: 20px;
  z-index: 210;

  .header-icon {
    font-size: 24px;
  }

  &.is-collapse {
    left: 60px;
    border-top-left-radius: 0px;
  }
}

.el-tag {
  background-color: #cdf3df;
}

.el-divider--horizontal {
  margin: 12px 15px;
  width: calc(100% - 30px) !important;
}

.pop_hd {
  width: 280px;
  height: 120px;
  background: url("../../assets/pop-img.jpg") center center no-repeat;

  .iconfont {
    font-size: 18px;
  }
}

.pop_content {
  padding: 12px 0;
}

.search {
  .el-input__suffix {
    .el-input__suffix-inner {
      &:hover {
        cursor: pointer;
        color: #07c160;
      }
    }
  }
}
</style>

